import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGES, useT } from "../i18n";

// Compact language picker; language names are always shown in English
const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang, t } = useT();
  return (
    <label className={`lang-switch ${className}`}>
      <FontAwesomeIcon icon={faGlobe} aria-hidden="true" />
      <span className="visually-hidden">{t("Language")}</span>
      <select value={lang} onChange={(e) => setLang(e.target.value)} aria-label={t("Language")}>
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
